const fields = [
  'AnmeldungBNetzAErforderlich',
  'AnmeldungBNetzAErfolgt',
  'Foerderung_vorhanden',
  'Foerderung',
  'FoerderungEnde',
  'FoerderungClearing',
]

const key = 'Dienstleistungen'

export const fieldOrderDienstleistungen = { [key]: { fields } }
export const formGroupDienstleistungen = {
  key,
  title: key,
  form: key,
}